import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  ClickAwayListener,
  Divider,
  Checkbox,
  Chip,
  Icon,
  Popper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  ListSubheader,
} from '@material-ui/core';
import { Fragment } from 'react';


class ListFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevSelected: [],
      selected: this.props.selected || [],
      label: this.props.label || 'Interest',
      open: false,
      disabled: this.props.disabled || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.selected) !== JSON.stringify(this.props.selected)) {
      this.setState({
        selected: this.props.selected || [],
      })
    }
  }

  handleToggle = (value) => {
    if (this.props.multiple === true) {
      const currentIndex = this.state.selected.indexOf(value);
      const newChecked = [...this.state.selected];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      this.setState(state => ({ selected: newChecked }));

    } else {
      const newChecked = [value]
      this.setState({ selected: newChecked});
    }
  }

  handleOpen = () => {
    this.setState(state => ({ open: !state.open, prevSelected: state.selected }));
  }

  handleDelete = () => {
    this.setState(state => ({ selected: (this.props.defaultSelected || []), prevSelected: state.selected }), this.handleChange);
  }

  handleChange = () => {
    if (this.state.prevSelected !== this.state.selected && !this.props.readonly && (!this.props.updateAfterClose || (this.props.updateAfterClose === true && this.state.open === false))) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: {
            [this.props.name]: this.state.selected,
          }
        }
      })
    }
  }

  handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ open: false }, this.handleChange)
  }

  renderButtonLabel() {
    return this.props.multiple === true ? (this.state.selected.length < 1 ? this.state.label : `${this.state.label} (${this.state.selected.length})`) : this.state.label
  }

  render() {
    const { classes, maxSelected, defaultSelected, description, multiple } = this.props;
    const { open, selected, disabled } = this.state;

    return(
      <div role="tab" className={classes.root}>
        <Chip
          disabled={disabled}
          aria-owns={open ? 'interests-list-grow' : null}
          aria-haspopup="true"
          buttonRef={node => { this.anchorEl = node; }}
          classes={{root: classes.chipRoot, avatar: classes.chipAvatar, icon: classes.chipIcon, colorPrimary: classes.chipSelected}}
          label={this.renderButtonLabel()}
          clickable={true}
          color={(open || (selected && selected.length > 0 && selected[0] !== defaultSelected[0])) ? "primary" : "default"}
          onClick={this.handleOpen}
          onDelete={!(selected && selected.length > 0 && selected[0] !== defaultSelected[0]) ? this.handleOpen : this.handleDelete}
          deleteIcon={!(selected && selected.length > 0 && selected[0] !== defaultSelected[0]) ?
            <Icon className={`${classes.icon} material-icons-outlined notranslate`}>keyboard_arrow_down</Icon>
            :
            <Icon className={`${classes.icon} material-icons-filled notranslate`}>cancel</Icon>
          }
          // icon={<Icon className={[classes.icon, "material-icons-outlined notranslate"]}>hiking</Icon>}
        />

        <Popper open={this.state.open}
          anchorEl={this.anchorEl}
          className={classes.popper}
          placement="bottom-start"
          disablePortal={false}
          modifiers={{
            flip: {
              enabled: false,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'window',
            },
            arrow: {
              enabled: false,
              element: this.anchorEl,
            },
          }}>
          <ClickAwayListener onClickAway={this.handleClose}>
            <List className={classes.list} subheader={<ListSubheader disableSticky>{description}</ListSubheader>}>
              {(this.props.list || []).map((category, i) => {
                return <Fragment key={i}>
                  <ListItem
                      disabled={disabled || category.disabled || ((maxSelected !== undefined && !selected.includes(category.value)) ? selected.length > (maxSelected - 1) : false)}
                      key={i}
                      style={{minHeight: 60}}
                      button
                      selected={(this.state.selected.length === 0 && defaultSelected === category.value) || this.state.selected.indexOf(category.value) !== -1}
                      onClick={(event) => this.handleToggle(category.value)}
                      classes={{root: classes.listItemRoot, selected: classes.listItemSelected}}
                    >
                    {category.icon && <ListItemIcon><Icon className={`${classes.icon} material-icons-outlined notranslate`}>{category.icon}</Icon></ListItemIcon>}
                    <ListItemText primary={category.title} secondary={category.secondary} classes={{ primary: classes.primaryText, secondary: classes.secondaryText }}/>
                    <ListItemSecondaryAction>
                      <Checkbox
                        edge="end"
                        size="small"
                        icon={<Icon className={`material-icons-outlined notranslate`}>blank</Icon>}
                        checkedIcon={<Icon className={`${classes.icon} material-icons-outlined notranslate`}>check</Icon>}
                        onChange={this.handleToggle.bind(this, category.value)}
                        checked={(this.state.selected.length === 0 && defaultSelected === category.value) || this.state.selected.indexOf(category.value) !== -1}
                        inputProps={{ 'aria-labelledby': `checkbox-list-secondary-label-${category.value}`}}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                  {category.divider === true && <Divider style={{backgroundColor: '#eee', margin: '5px 15px'}} />}
                </Fragment>
              })}
            </List>
          </ClickAwayListener>
        </Popper>
      </div>
    )
  }
}

const styles = theme => ({
  popper: {
    top: '4px !important',
    // left: '1px !important',
    // textAlign: 'left',
    zIndex: 100,
  },
  root: {
    fontSize: 12,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'inline-flex',
    position: 'relative',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    lineHeight: '1.4em',
    marginRight: 10,
    marginTop: 0,
    textAlign: 'left',
  },
  list: {
    maxWidth: 360,
    minWidth: 220,
    // boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    // borderRadius: 3,
    backgroundColor: '#fff',
    padding: '10px 10px 25px 10px',
    marginRight: 10,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    border: '1px solid #f5f5f5',
    borderRadius: 25,
    fontWeight: 600,
    maxHeight: '80vh',
    overflow: 'scroll',
  },
  listItemRoot: {
    borderRadius: 25,
    marginBottom: 3,
  },
  listItemSelected: {
    backgroundColor: 'rgba(7, 195, 153, 0.10) !important',
    // backgroundColor: '#fff !important',
  },
  primaryText: {
    fontSize: 13,
    fontWeight: 600,
  },
  secondaryText: {
    fontSize: 12,
    fontWeight: 500,
  },
  icon: {
    fontSize: 21,
    fontWeight: 400,
    marginTop: 0,
    marginRight: -10,
    marginLeft: -7,
    padding: '10px !important',
    verticalAlign: 'middle',
    color: '#828282',
  },
  chipSelected: {
    backgroundColor: '#07c3991a !important',
    boxShadow: 'none !important',
    border: '1px solid #02c39a !important',
  },
  chipRoot: {
    padding: '20px 10px 20px 10px',
    borderRadius: 50,
    marginRight: 0,
    marginBottom: 10,
    // boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    fontWeight: 500,
    fontSize: 14,
    border: '1px solid #ddd',
    backgroundColor: '#fff',

    '&:hover': {
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  chipAvatar: {
    width: '44px !important',
    height: '44px !important',
    marginRight: '4px !important',
  },
});

export default withStyles(styles)(ListFilter);